import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Header, Dropdown, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import AppContainer from '../app-container/AppContainer';
import BudgetsMenuItems from './BudgetsMenuItems';
import SubContainer from '../app-container/SubContainer';
import { hasBusinessPermission } from '../../helpers/permissions';

const BudgetsContainer = ({ children, ...props }) => {
    const companies = useSelector(state => state.budgetsApp.companies);
    const [pickerValue, setPickerValue] = useState('');

    const { companyId } = props.match.params;
    const currentCompany = companies.find(c => c.id == companyId);
    
    function renderPicker(customTrigger) {
        const options = companies.map(c => ({
            key: c.id,
            value: c.id,
            text: c.name,
            as: Link,
            to: `/company/${c.id}`,
        }));
        const value = companyId;

        function renderCustomTrigger() {
            if (customTrigger) {
                return (
                    <Fragment>
                        <div style={{ display: pickerValue ? 'none' : 'flex', color: '#a7a7a7', marginBottom: -15 }}>
                            <Icon name='search' style={{ fontSize: 14 }} /> {i18next.t('switchCompany')}
                        </div>
                        <Header size='large'>
                            <Header.Content>
                                {currentCompany.name}
                                <Header.Subheader>{'company'}</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </Fragment>
                );
            }
        }

        return (
            <Dropdown
                trigger={renderCustomTrigger()}
                options={options}
                value={value}
                fluid
                item
                search
                placeholder="search"
                icon={null}
                onSearchChange={(e, { searchQuery }) => setPickerValue(searchQuery)}
            />
        );
    }

    function renderMenuItems(iconOnly) {
        return <BudgetsMenuItems iconOnly={iconOnly} companyId={companyId} {...props} />;
    }

    if (!hasBusinessPermission()) {
        return <Redirect to={{ pathname: '/' }} />;
    }

    if (!currentCompany) return <AppContainer {...props}>{children}</AppContainer>;

    return (
        <SubContainer
            renderPicker={renderPicker}
            renderMenuItems={renderMenuItems}
            menuItemsCount={5}
            {...props}
        >
            {children}
        </SubContainer>
    );
};

BudgetsContainer.propTypes = {
    children: PropTypes.any,
    
    match: PropTypes.object
};

export default BudgetsContainer;
